// import React, { useState, useEffect, useCallback } from 'react';
// import axios from 'axios';
// import {
//     Box, Typography, Chip, CircularProgress,
//     Alert, Container, alpha, Button, Paper, Divider
// } from '@mui/material';
// import VideoLibraryIcon from '@mui/icons-material/VideoLibrary';
// import LinkIcon from '@mui/icons-material/Link';
// import PlayArrowIcon from '@mui/icons-material/PlayArrow';
// import OpenInNewIcon from '@mui/icons-material/OpenInNew';
// import ArrowBackIcon from '@mui/icons-material/ArrowBack';
// import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';

// const API_BASE_URL = process.env.REACT_APP_API_BASE || 'http://localhost:5000';

// const TrainingViewer = () => {
//     const [resources, setResources] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState(null);
//     const [selectedResource, setSelectedResource] = useState(null);

//     const fetchResources = useCallback(async () => {
//         try {
//             const token = localStorage.getItem('jwtToken');
//             const res = await axios.get(`${API_BASE_URL}/api/training`, {
//                 headers: { Authorization: `Bearer ${token}` }
//             });
//             setResources(res.data);
//         } catch (err) {
//             console.error("Failed to fetch training resources", err);
//             setError("Failed to load training resources. Please try again later.");
//         } finally {
//             setLoading(false);
//         }
//     }, []);

//     useEffect(() => {
//         fetchResources();
//     }, [fetchResources]);

//     const getFullUrl = useCallback((path) => {
//         if (!path) return null;
//         return path.startsWith('http') ? path : `${API_BASE_URL}${path}`;
//     }, []);

//     const getYouTubeThumbnail = useCallback((url) => {
//         if (!url) return null;
        
//         const patterns = [
//             /(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([^&?/]+)/,
//             /youtube\.com\/watch\?.*v=([^&?/]+)/
//         ];
        
//         for (const pattern of patterns) {
//             const match = url.match(pattern);
//             if (match && match[1]) {
//                 return `https://img.youtube.com/vi/${match[1]}/maxresdefault.jpg`;
//             }
//         }
//         return null;
//     }, []);

//     const getYouTubeEmbedUrl = useCallback((url) => {
//         if (!url) return null;
        
//         const patterns = [
//             /(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([^&?/]+)/,
//             /youtube\.com\/watch\?.*v=([^&?/]+)/
//         ];
        
//         for (const pattern of patterns) {
//             const match = url.match(pattern);
//             if (match && match[1]) {
//                 return `https://www.youtube.com/embed/${match[1]}`;
//             }
//         }
//         return url;
//     }, []);

//     const handleBackClick = useCallback(() => {
//         setSelectedResource(null);
//     }, []);

//     const handleResourceClick = useCallback((resource) => {
//         setSelectedResource(resource);
//     }, []);

//     const handleOpenLink = useCallback((url) => {
//         window.open(url, '_blank');
//     }, []);

//     if (loading) {
//         return (
//             <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}>
//                 <CircularProgress sx={{ color: '#11224d' }} />
//             </Box>
//         );
//     }

//     if (error) {
//         return (
//             <Container maxWidth="lg" sx={{ mt: 4 }}>
//                 <Alert severity="error">{error}</Alert>
//             </Container>
//         );
//     }

//     if (selectedResource) {
//         return (
//             <Container maxWidth="lg" sx={{ py: 1 }}>
//                 <Button 
//                     startIcon={<ArrowBackIcon />} 
//                     onClick={handleBackClick}
//                     sx={{ 
//                         mb: -1, 
//                         fontWeight: 'bold', 
//                         color: '#11224d',
//                         textTransform: 'none',
//                         fontSize: '1rem',
//                         '&:hover': { backgroundColor: alpha('#11224d', 0.05) }
//                     }}
//                 >
//                     Back to Training
//                 </Button>
                
//                 <Paper 
//                     elevation={0} 
//                     sx={{ 
//                         overflow: 'hidden', 
//                         borderRadius: 3, 
//                         border: '1px solid', 
//                         borderColor: 'divider',
//                         boxShadow: '0 4px 20px rgba(0,0,0,0.05)',
//                         mt: 0
//                     }}
//                 >
//                     <Box sx={{ 
//                         bgcolor: '#000', 
//                         width: '100%', 
//                         height: { xs: 250, md: 500 }, 
//                         display: 'flex', 
//                         alignItems: 'center', 
//                         justifyContent: 'center', 
//                         position: 'relative',
//                         backgroundImage: 'none'
//                     }}>
//                           {selectedResource.type === 'video' ? (
//                              selectedResource.url && (selectedResource.url.includes('youtube.com') || selectedResource.url.includes('youtu.be')) ? (
//                                  <iframe
//                                      width="100%"
//                                      height="100%"
//                                      src={getYouTubeEmbedUrl(selectedResource.url)}
//                                      title={selectedResource.title}
//                                      frameBorder="0"
//                                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
//                                      allowFullScreen
//                                      style={{ border: 'none' }}
//                                  />
//                              ) : (
//                                  <video 
//                                     controls 
//                                     autoPlay 
//                                     src={getFullUrl(selectedResource.url)} 
//                                     style={{ width: '100%', height: '100%', maxHeight: '100%' }} 
//                                  />
//                              )
//                           ) : (
//                              <iframe
//                                  width="100%"
//                                  height="100%"
//                                  src={selectedResource.url}
//                                  title={selectedResource.title}
//                                  frameBorder="0"
//                                  style={{ border: 'none', backgroundColor: '#fff' }}
//                              />
//                           )}
//                     </Box>

//                     <Box sx={{ p: { xs: 2.5, md: 4 } }}>
//                         <Box sx={{ 
//                             display: 'flex', 
//                             alignItems: 'center', 
//                             gap: 2, 
//                             mb: 3,
//                             flexWrap: 'wrap'
//                         }}>
//                             <Chip 
//                                 icon={selectedResource.type === 'video' ? 
//                                     <VideoLibraryIcon sx={{ fontSize: 18 }} /> : 
//                                     <LinkIcon sx={{ fontSize: 18 }} />
//                                 }
//                                 label={selectedResource.type === 'video' ? 'Video Tutorial' : 'External Link'} 
//                                 sx={{ 
//                                     bgcolor: selectedResource.type === 'video' ? alpha('#11224d', 0.1) : alpha('#ff9800', 0.1),
//                                     color: selectedResource.type === 'video' ? '#11224d' : '#f57c00',
//                                     fontWeight: 700, 
//                                     fontSize: '0.875rem',
//                                     height: 32,
//                                     px: 1,
//                                     '& .MuiChip-icon': {
//                                         color: 'inherit'
//                                     }
//                                 }}
//                             />
//                             <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
//                                 <CalendarMonthIcon sx={{ fontSize: 18, color: 'text.secondary' }} />
//                                 <Typography variant="body2" sx={{ 
//                                     color: 'text.secondary', 
//                                     fontWeight: 500,
//                                     fontSize: '0.9rem'
//                                 }}>
//                                     {new Date(selectedResource.created_at).toLocaleDateString('en-US', { 
//                                         weekday: 'long',
//                                         month: 'long', 
//                                         day: 'numeric', 
//                                         year: 'numeric' 
//                                     })}
//                                 </Typography>
//                             </Box>
//                         </Box>

//                         <Typography 
//                             variant="h3" 
//                             sx={{ 
//                                 fontWeight: 600, 
//                                 color: '#11224d', 
//                                 mb: 3,
//                                 fontSize: { xs: '1.75rem', sm: '2rem', md: '2.25rem' },
//                                 lineHeight: 1.3,
//                                 letterSpacing: '-0.01em',
//                                 fontFamily: '"Inter", "Segoe UI", "Roboto", "Helvetica", sans-serif'
//                             }}
//                         >
//                             {selectedResource.title}
//                         </Typography>
                        
//                         <Divider sx={{ my: 3 }} />
                        
//                         <Typography 
//                             variant="body1" 
//                             sx={{ 
//                                 lineHeight: 1.8, 
//                                 color: 'text.secondary', 
//                                 whiteSpace: 'pre-wrap',
//                                 fontSize: '1.05rem'
//                             }}
//                         >
//                             {selectedResource.description || "No description provided."}
//                         </Typography>

//                         {selectedResource.type === 'link' && (
//                             <Box sx={{ mt: 3 }}>
//                                 <Button 
//                                     variant="outlined" 
//                                     color="primary"
//                                     endIcon={<OpenInNewIcon />}
//                                     onClick={() => handleOpenLink(selectedResource.url)}
//                                     sx={{ fontWeight: 'bold', borderRadius: 2 }}
//                                 >
//                                     Open in New Tab
//                                 </Button>
//                             </Box>
//                         )}
//                     </Box>
//                 </Paper>
//             </Container>
//         );
//     }

//     return (
//         <Container maxWidth="xl" sx={{ py: 4 }}>
//             {resources.length === 0 ? (
//                 <Box sx={{ 
//                     textAlign: 'center', 
//                     py: 10, 
//                     backgroundColor: alpha('#11224d', 0.03), 
//                     borderRadius: 4,
//                     maxWidth: 1200,
//                     mx: 'auto'
//                 }}>
//                     <VideoLibraryIcon sx={{ fontSize: 64, color: '#11224d', opacity: 0.2, mb: 2 }} />
//                     <Typography variant="h6" color="text.secondary">No training resources available yet</Typography>
//                 </Box>
//             ) : (
//                 <Box sx={{ 
//                     display: 'grid',
//                     gridTemplateColumns: {
//                         xs: '1fr',
//                         sm: 'repeat(2, 1fr)',
//                         lg: 'repeat(3, 1fr)',
//                         xl: 'repeat(3, 1fr)'
//                     },
//                     gap: { xs: 2, sm: 2.5, md: 3 },
//                     width: '100%'
//                 }}>
//                     {resources.map((resource) => (
//                         <Paper 
//                             key={resource.id}
//                             elevation={0}
//                             sx={{ 
//                                 display: 'flex', 
//                                 flexDirection: 'column',
//                                 height: '100%',
//                                 minHeight: { xs: 420, sm: 450 },
//                                 maxHeight: { xs: 420, sm: 450 },
//                                 borderRadius: 3,
//                                 border: '1px solid',
//                                 borderColor: 'divider',
//                                 transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
//                                 cursor: 'pointer',
//                                 overflow: 'hidden',
//                                 position: 'relative',
//                                 '&:hover': {
//                                     transform: 'translateY(-6px)',
//                                     boxShadow: '0 12px 32px rgba(255, 179, 0, 0.25)',
//                                     borderColor: '#ffb300',
//                                     '& .play-button': {
//                                         transform: 'translate(-50%, -50%) scale(1.1)',
//                                     }
//                                 }
//                             }}
//                             onClick={() => handleResourceClick(resource)}
//                         >
//                             <Box sx={{ 
//                                 position: 'relative', 
//                                 height: 200, 
//                                 bgcolor: '#000', 
//                                 overflow: 'hidden',
//                                 flexShrink: 0
//                             }}>
//                                 {resource.type === 'video' ? (
//                                     <Box sx={{ position: 'relative', width: '100%', height: '100%' }}>
//                                         {resource.url && (resource.url.includes('youtube.com') || resource.url.includes('youtu.be')) ? (
//                                             <>
//                                                 <Box
//                                                     component="img"
//                                                     src={getYouTubeThumbnail(resource.url)}
//                                                     alt={resource.title}
//                                                     sx={{
//                                                         width: '100%',
//                                                         height: '100%',
//                                                         objectFit: 'cover',
//                                                         opacity: 0.85
//                                                     }}
//                                                     onError={(e) => {
//                                                         e.target.src = getYouTubeThumbnail(resource.url).replace('maxresdefault', 'hqdefault');
//                                                     }}
//                                                 />
//                                                 <Box 
//                                                     className="play-button"
//                                                     sx={{ 
//                                                         position: 'absolute', 
//                                                         top: '50%', 
//                                                         left: '50%', 
//                                                         transform: 'translate(-50%, -50%)', 
//                                                         width: 56, 
//                                                         height: 56, 
//                                                         borderRadius: '50%', 
//                                                         bgcolor: 'rgba(255,0,0,0.8)', 
//                                                         display: 'flex', 
//                                                         alignItems: 'center', 
//                                                         justifyContent: 'center',
//                                                         border: '3px solid rgba(255,255,255,0.9)',
//                                                         boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
//                                                         transition: 'transform 0.3s ease'
//                                                     }}
//                                                 >
//                                                     <PlayArrowIcon sx={{ color: 'white', fontSize: 32, ml: 0.5 }} />
//                                                 </Box>
//                                             </>
//                                         ) : (
//                                             <>
//                                                 <video 
//                                                     src={getFullUrl(resource.url)} 
//                                                     style={{ 
//                                                         width: '100%', 
//                                                         height: '100%', 
//                                                         objectFit: 'cover', 
//                                                         opacity: 0.85 
//                                                     }} 
//                                                     muted 
//                                                 />
//                                                 <Box 
//                                                     className="play-button"
//                                                     sx={{ 
//                                                         position: 'absolute', 
//                                                         top: '50%', 
//                                                         left: '50%', 
//                                                         transform: 'translate(-50%, -50%)', 
//                                                         width: 56, 
//                                                         height: 56, 
//                                                         borderRadius: '50%', 
//                                                         bgcolor: 'rgba(255,255,255,0.3)', 
//                                                         backdropFilter: 'blur(8px)', 
//                                                         display: 'flex', 
//                                                         alignItems: 'center', 
//                                                         justifyContent: 'center',
//                                                         border: '3px solid rgba(255,255,255,0.9)',
//                                                         boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
//                                                         transition: 'transform 0.3s ease'
//                                                     }}
//                                                 >
//                                                     <PlayArrowIcon sx={{ color: 'white', fontSize: 32, ml: 0.5 }} />
//                                                 </Box>
//                                             </>
//                                         )}
//                                     </Box>
//                                 ) : (
//                                     <Box sx={{ 
//                                         width: '100%', 
//                                         height: '100%', 
//                                         background: 'linear-gradient(135deg, #1a2f63 0%, #11224d 50%, #0a1633 100%)', 
//                                         display: 'flex', 
//                                         alignItems: 'center', 
//                                         justifyContent: 'center',
//                                         position: 'relative'
//                                     }}>
//                                         <LinkIcon sx={{ color: 'white', fontSize: 56, opacity: 0.6 }} />
//                                         <Box 
//                                             className="play-button"
//                                             sx={{ 
//                                                 position: 'absolute', 
//                                                 top: '50%', 
//                                                 left: '50%', 
//                                                 transform: 'translate(-50%, -50%)', 
//                                                 width: 56, 
//                                                 height: 56, 
//                                                 borderRadius: '50%', 
//                                                 bgcolor: 'rgba(255,255,255,0.3)', 
//                                                 backdropFilter: 'blur(8px)', 
//                                                 display: 'flex', 
//                                                 alignItems: 'center', 
//                                                 justifyContent: 'center',
//                                                 border: '3px solid rgba(255,255,255,0.9)',
//                                                 boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
//                                                 transition: 'transform 0.3s ease'
//                                             }}
//                                         >
//                                             <PlayArrowIcon sx={{ color: 'white', fontSize: 32, ml: 0.5 }} />
//                                         </Box>
//                                     </Box>
//                                 )}
                                
//                                 <Chip 
//                                     label={resource.type === 'video' ? 'Video' : 'Link'} 
//                                     size="small"
//                                     sx={{ 
//                                         position: 'absolute', 
//                                         top: 12, 
//                                         right: 12, 
//                                         bgcolor: 'rgba(0,0,0,0.75)', 
//                                         color: 'white', 
//                                         fontWeight: 700, 
//                                         fontSize: '0.7rem',
//                                         height: 22,
//                                         backdropFilter: 'blur(4px)',
//                                         textTransform: 'uppercase',
//                                         letterSpacing: '0.5px'
//                                     }}
//                                 />
//                             </Box>
                            
//                             <Box sx={{ 
//                                 display: 'flex', 
//                                 flexDirection: 'column',
//                                 flexGrow: 1,
//                                 p: { xs: 2, sm: 2.5 },
//                                 height: 'calc(100% - 200px)',
//                                 overflow: 'hidden'
//                             }}>
//                                 <Box sx={{ 
//                                     display: 'flex', 
//                                     alignItems: 'center', 
//                                     gap: 0.5, 
//                                     mb: 1.5,
//                                     flexShrink: 0
//                                 }}>
//                                     <CalendarMonthIcon sx={{ fontSize: 15, color: 'text.secondary' }} />
//                                     <Typography variant="caption" sx={{ 
//                                         color: 'text.secondary', 
//                                         fontWeight: 500,
//                                         fontSize: '0.7rem'
//                                     }}>
//                                         {new Date(resource.created_at).toLocaleDateString('en-US', { 
//                                             month: 'short', 
//                                             day: 'numeric', 
//                                             year: 'numeric' 
//                                         })}
//                                     </Typography>
//                                 </Box>
                                
//                                 <Typography sx={{ 
//                                     fontWeight: 700, 
//                                     color: '#11224d', 
//                                     mb: 1.5, 
//                                     lineHeight: 1.4,
//                                     fontSize: { xs: '1rem', sm: '1.05rem' },
//                                     height: '2.8em',
//                                     overflow: 'hidden',
//                                     display: '-webkit-box',
//                                     WebkitLineClamp: 2,
//                                     WebkitBoxOrient: 'vertical',
//                                     flexShrink: 0
//                                 }}>
//                                     {resource.title}
//                                 </Typography>
                                
//                                 <Typography variant="body2" sx={{ 
//                                     color: 'text.secondary',
//                                     overflow: 'hidden',
//                                     display: '-webkit-box',
//                                     WebkitLineClamp: 2,
//                                     WebkitBoxOrient: 'vertical',
//                                     lineHeight: 1.6,
//                                     fontSize: '0.85rem',
//                                     flexShrink: 0,
//                                     mb: 2,
//                                     height: '3.2em'
//                                 }}>
//                                     {resource.description || "No description provided."}
//                                 </Typography>
                                
//                                 <Box sx={{ flexGrow: 1 }} />
                                
//                                 <Box sx={{ 
//                                     flexShrink: 0,
//                                     mt: 'auto'
//                                 }}>
//                                     <Button 
//                                         variant="outlined" 
//                                         fullWidth 
//                                         size="medium"
//                                         sx={{ 
//                                             borderRadius: 2, 
//                                             textTransform: 'none', 
//                                             fontWeight: 700,
//                                             fontSize: { xs: '0.85rem', sm: '0.9rem' },
//                                             borderColor: '#e0e0e0',
//                                             color: '#11224d',
//                                             py: { xs: 0.9, sm: 1 },
//                                             transition: 'all 0.2s ease',
//                                             '&:hover': { 
//                                                 borderColor: '#ffb300', 
//                                                 bgcolor: alpha('#ffb300', 0.06),
//                                                 transform: 'translateY(-1px)',
//                                                 boxShadow: '0 2px 8px rgba(255, 179, 0, 0.2)'
//                                             }
//                                         }}
//                                     >
//                                         {resource.type === 'video' ? 'Watch Now' : 'View Content'}
//                                     </Button>
//                                 </Box>
//                             </Box>
//                         </Paper>
//                     ))}
//                 </Box>
//             )}
//         </Container>
//     );
// };

import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import {
    Box, Typography, Chip, CircularProgress,
    Alert, Container, alpha, Button, Paper, Divider
} from '@mui/material';
import VideoLibraryIcon from '@mui/icons-material/VideoLibrary';
import LinkIcon from '@mui/icons-material/Link';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
// OpenInNewIcon is no longer used for the button, but keeping import just in case
import OpenInNewIcon from '@mui/icons-material/OpenInNew'; 
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';

const API_BASE_URL = process.env.REACT_APP_API_BASE || 'http://localhost:5000';

const TrainingViewer = () => {
    const [resources, setResources] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [selectedResource, setSelectedResource] = useState(null);
    // New state to toggle external link embedding
    const [isPlayingExternal, setIsPlayingExternal] = useState(false);

    const fetchResources = useCallback(async () => {
        try {
            const token = localStorage.getItem('jwtToken');
            const res = await axios.get(`${API_BASE_URL}/api/training`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setResources(res.data);
        } catch (err) {
            console.error("Failed to fetch training resources", err);
            setError("Failed to load training resources. Please try again later.");
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchResources();
    }, [fetchResources]);

    const getFullUrl = useCallback((path) => {
        if (!path) return null;
        return path.startsWith('http') ? path : `${API_BASE_URL}/${path}`;
    }, []);

    const getYouTubeThumbnail = useCallback((url) => {
        if (!url) return null;
        
        const patterns = [
            /(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([^&?/]+)/,
            /youtube\.com\/watch\?.*v=([^&?/]+)/
        ];
        
        for (const pattern of patterns) {
            const match = url.match(pattern);
            if (match && match[1]) {
                return `https://img.youtube.com/vi/${match[1]}/maxresdefault.jpg`;
            }
        }
        return null;
    }, []);

    // return video id or null
    const getYouTubeVideoId = useCallback((url) => {
        if (!url) return null;
        try {
            const parsed = new URL(url);
            const host = parsed.hostname.replace('www.', '');
            if (host === 'youtu.be') {
                const id = parsed.pathname.slice(1);
                return id || null;
            }
            if (host === 'youtube.com' || host.endsWith('.youtube.com')) {
                // check /embed/ID
                const embedMatch = parsed.pathname.match(/\/embed\/([^/?]+)/);
                if (embedMatch && embedMatch[1]) return embedMatch[1];
                // check v= param
                const v = parsed.searchParams.get('v');
                if (v) return v;
            }
        } catch (e) {
            // fallback regex
            const patterns = [
                /(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([^&?\/]+)/,
                /youtube\.com\/watch\?.*v=([^&?\/]+)/
            ];
            for (const pattern of patterns) {
                const match = url.match(pattern);
                if (match && match[1]) return match[1];
            }
        }
        return null;
    }, []);

    const getYouTubeEmbedUrl = useCallback((url) => {
        const id = getYouTubeVideoId(url);
        if (!id) return null;
        // prefer nocookie for privacy
        return `https://www.youtube-nocookie.com/embed/${id}?rel=0`;
    }, [getYouTubeVideoId]);

    const handleBackClick = useCallback(() => {
        setSelectedResource(null);
        setIsPlayingExternal(false); // Reset on back
    }, []);

    const handleResourceClick = useCallback((resource) => {
        setSelectedResource(resource);
        setIsPlayingExternal(false); // Reset when opening new resource
    }, []);

    // This is optional now, depending on if you still want a fallback
    const handleOpenLink = useCallback((url) => {
        window.open(url, '_blank');
    }, []);

    const handlePlayOrOpen = useCallback((resource, e) => {
        if (e && e.stopPropagation) e.stopPropagation();
        const url = getFullUrl(resource.url);
        // If it's a YouTube link and we can embed, open inline. Otherwise open in new tab.
        const embed = getYouTubeEmbedUrl(url);
        if (embed) {
            setSelectedResource(resource);
            setIsPlayingExternal(true);
            return;
        }
        // Not embedable -> open in new tab
        window.open(url, '_blank');
    }, [getFullUrl, getYouTubeEmbedUrl]);

    if (loading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}>
                <CircularProgress sx={{ color: '#11224d' }} />
            </Box>
        );
    }

    if (error) {
        return (
            <Container maxWidth="lg" sx={{ mt: 4 }}>
                <Alert severity="error">{error}</Alert>
            </Container>
        );
    }

    if (selectedResource) {
        return (
            <Container maxWidth="lg" sx={{ py: 1 }}>
                <Button 
                    startIcon={<ArrowBackIcon />} 
                    onClick={handleBackClick}
                    sx={{ 
                        mb: -1, 
                        fontWeight: 'bold', 
                        color: '#11224d',
                        textTransform: 'none',
                        fontSize: '1rem',
                        '&:hover': { backgroundColor: alpha('#11224d', 0.05) }
                    }}
                >
                    Back to Training
                </Button>
                
                <Paper 
                    elevation={0} 
                    sx={{ 
                        overflow: 'hidden', 
                        borderRadius: 3, 
                        border: '1px solid', 
                        borderColor: 'divider',
                        boxShadow: '0 4px 20px rgba(0,0,0,0.05)',
                        mt: 0
                    }}
                >
                    <Box sx={{ 
                        bgcolor: '#000', 
                        width: '100%', 
                        height: { xs: 250, md: 500 }, 
                        display: 'flex', 
                        alignItems: 'center', 
                        justifyContent: 'center', 
                        position: 'relative',
                        // If it's a video OR if we are playing external content, remove the gradient
                        backgroundImage: (selectedResource.type !== 'video' && !isPlayingExternal) ? 'radial-gradient(circle at center, #1a2f63 0%, #11224d 50%, #0a1633 100%)' : 'none'
                    }}>
                          {selectedResource.type === 'video' ? (
                             (() => {
                                 const embed = getYouTubeEmbedUrl(getFullUrl(selectedResource.url));
                                 if (embed) {
                                     return (
                                         <iframe
                                             width="100%"
                                             height="100%"
                                             src={embed}
                                             title={selectedResource.title}
                                             frameBorder="0"
                                             allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                             allowFullScreen
                                             style={{ border: 'none' }}
                                         />
                                     );
                                 }
                                 // Not a YouTube-embedable video -> show native video tag or fallback open link
                                 const full = getFullUrl(selectedResource.url);
                                 if (full && (full.endsWith('.mp4') || full.endsWith('.webm') || full.endsWith('.ogg'))) {
                                     return (
                                         <video
                                             controls
                                             autoPlay
                                             src={full}
                                             style={{ width: '100%', height: '100%', maxHeight: '100%' }}
                                         />
                                     );
                                 }
                                 return (
                                     <Box sx={{ textAlign: 'center', color: 'white', p: 3 }}>
                                         <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>Video cannot be embedded</Typography>
                                         <Button variant="contained" onClick={() => window.open(getFullUrl(selectedResource.url), '_blank')} sx={{ mt: 2 }}>Open on YouTube</Button>
                                     </Box>
                                 );
                             })()
                          ) : (
                             // Logic for External Links
                             (() => {
                                 const full = getFullUrl(selectedResource.url);
                                 const embed = getYouTubeEmbedUrl(full);
                                 if (isPlayingExternal && embed) {
                                    return (
                                        <iframe
                                            width="100%"
                                            height="100%"
                                            src={embed}
                                            title={selectedResource.title}
                                            style={{ border: 'none', backgroundColor: '#fff' }}
                                            allowFullScreen
                                        />
                                    );
                                 }
                                 if (isPlayingExternal && !embed) {
                                     // Can't embed -> open in new tab and reset
                                     window.open(full, '_blank');
                                     setIsPlayingExternal(false);
                                     return (
                                         <Box sx={{ textAlign: 'center', color: 'white', p: 3 }}>
                                             <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>Opened in new tab</Typography>
                                         </Box>
                                     );
                                 }
                                 return (
                                     <Box sx={{ textAlign: 'center', color: 'white', p: 3 }}>
                                         <LinkIcon sx={{ fontSize: 80, opacity: 0.5, mb: 2 }} />
                                         <Typography variant="h5" gutterBottom sx={{ fontWeight: 600 }}>External Resource</Typography>
                                         <Button 
                                             variant="contained" 
                                             color="warning" 
                                             size="large"
                                             startIcon={<PlayArrowIcon />}
                                             onClick={() => handlePlayOrOpen(selectedResource)}
                                             sx={{ fontWeight: 'bold', px: 4, borderRadius: 2, mt: 2 }}
                                         >
                                             Play 
                                         </Button>
                                     </Box>
                                 );
                             })()
                          )}
                    </Box>

                    <Box sx={{ p: { xs: 2.5, md: 4 } }}>
                        <Box sx={{ 
                            display: 'flex', 
                            alignItems: 'center', 
                            gap: 2, 
                            mb: 3,
                            flexWrap: 'wrap'
                        }}>
                            <Chip 
                                icon={selectedResource.type === 'video' ? 
                                    <VideoLibraryIcon sx={{ fontSize: 18 }} /> : 
                                    <LinkIcon sx={{ fontSize: 18 }} />
                                }
                                label={selectedResource.type === 'video' ? 'Video Tutorial' : 'External Link'} 
                                sx={{ 
                                    bgcolor: selectedResource.type === 'video' ? alpha('#11224d', 0.1) : alpha('#ff9800', 0.1),
                                    color: selectedResource.type === 'video' ? '#11224d' : '#f57c00',
                                    fontWeight: 700, 
                                    fontSize: '0.875rem',
                                    height: 32,
                                    px: 1,
                                    '& .MuiChip-icon': {
                                        color: 'inherit'
                                    }
                                }}
                            />
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
                                <CalendarMonthIcon sx={{ fontSize: 18, color: 'text.secondary' }} />
                                <Typography variant="body2" sx={{ 
                                    color: 'text.secondary', 
                                    fontWeight: 500,
                                    fontSize: '0.9rem'
                                }}>
                                    {new Date(selectedResource.created_at).toLocaleDateString('en-US', { 
                                        weekday: 'long',
                                        month: 'long', 
                                        day: 'numeric', 
                                        year: 'numeric' 
                                    })}
                                </Typography>
                            </Box>
                        </Box>

                        <Typography 
                            variant="h3" 
                            sx={{ 
                                fontWeight: 600, 
                                color: '#11224d', 
                                mb: 3,
                                fontSize: { xs: '1.75rem', sm: '2rem', md: '2.25rem' },
                                lineHeight: 1.3,
                                letterSpacing: '-0.01em',
                                fontFamily: '"Inter", "Segoe UI", "Roboto", "Helvetica", sans-serif'
                            }}
                        >
                            {selectedResource.title}
                        </Typography>
                        
                        <Divider sx={{ my: 3 }} />
                        
                        <Typography 
                            variant="body1" 
                            sx={{ 
                                lineHeight: 1.8, 
                                color: 'text.secondary', 
                                whiteSpace: 'pre-wrap',
                                fontSize: '1.05rem'
                            }}
                        >
                            {selectedResource.description || "No description provided."}
                        </Typography>
                    </Box>
                </Paper>
            </Container>
        );
    }

    return (
        <Container maxWidth="xl" sx={{ py: 4 }}>
            {resources.length === 0 ? (
                <Box sx={{ 
                    textAlign: 'center', 
                    py: 10, 
                    backgroundColor: alpha('#11224d', 0.03), 
                    borderRadius: 4,
                    maxWidth: 1200,
                    mx: 'auto'
                }}>
                    <VideoLibraryIcon sx={{ fontSize: 64, color: '#11224d', opacity: 0.2, mb: 2 }} />
                    <Typography variant="h6" color="text.secondary">No training resources available yet</Typography>
                </Box>
            ) : (
                <Box sx={{ 
                    display: 'grid',
                    gridTemplateColumns: {
                        xs: '1fr',
                        sm: 'repeat(2, 1fr)',
                        lg: 'repeat(3, 1fr)',
                        xl: 'repeat(3, 1fr)'
                    },
                    gap: { xs: 2, sm: 2.5, md: 3 },
                    width: '100%'
                }}>
                    {resources.map((resource) => (
                        <Paper 
                            key={resource.id}
                            elevation={0}
                            sx={{ 
                                display: 'flex', 
                                flexDirection: 'column',
                                height: '100%',
                                minHeight: { xs: 420, sm: 450 },
                                maxHeight: { xs: 420, sm: 450 },
                                borderRadius: 3,
                                border: '1px solid',
                                borderColor: 'divider',
                                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                cursor: 'pointer',
                                overflow: 'hidden',
                                position: 'relative',
                                '&:hover': {
                                    transform: 'translateY(-6px)',
                                    boxShadow: '0 12px 32px rgba(255, 179, 0, 0.25)',
                                    borderColor: '#ffb300',
                                    '& .play-button': {
                                        transform: 'translate(-50%, -50%) scale(1.1)',
                                    }
                                }
                            }}
                            onClick={() => handleResourceClick(resource)}
                        >
                            <Box sx={{ 
                                position: 'relative', 
                                height: 200, 
                                bgcolor: '#000', 
                                overflow: 'hidden',
                                flexShrink: 0
                            }}>
                                {resource.type === 'video' ? (
                                    <Box sx={{ position: 'relative', width: '100%', height: '100%' }}>
                                        {resource.url && (resource.url.includes('youtube.com') || resource.url.includes('youtu.be')) ? (
                                            <>
                                                <Box
                                                    component="img"
                                                    src={getYouTubeThumbnail(resource.url)}
                                                    alt={resource.title}
                                                    sx={{
                                                        width: '100%',
                                                        height: '100%',
                                                        objectFit: 'cover',
                                                        opacity: 0.85
                                                    }}
                                                    onError={(e) => {
                                                        e.target.src = getYouTubeThumbnail(resource.url).replace('maxresdefault', 'hqdefault');
                                                    }}
                                                />
                                                <Box 
                                                    className="play-button"
                                                    sx={{ 
                                                        position: 'absolute', 
                                                        top: '50%', 
                                                        left: '50%', 
                                                        transform: 'translate(-50%, -50%)', 
                                                        width: 56, 
                                                        height: 56, 
                                                        borderRadius: '50%', 
                                                        bgcolor: 'rgba(255,0,0,0.8)', 
                                                        display: 'flex', 
                                                        alignItems: 'center', 
                                                        justifyContent: 'center',
                                                        border: '3px solid rgba(255,255,255,0.9)',
                                                        boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
                                                        transition: 'transform 0.3s ease'
                                                    }}
                                                >
                                                    <PlayArrowIcon sx={{ color: 'white', fontSize: 32, ml: 0.5 }} />
                                                </Box>
                                            </>
                                        ) : (
                                            <>
                                                <video 
                                                    src={getFullUrl(resource.url)} 
                                                    style={{ 
                                                        width: '100%', 
                                                        height: '100%', 
                                                        objectFit: 'cover', 
                                                        opacity: 0.85 
                                                    }} 
                                                    muted 
                                                />
                                                <Box 
                                                    className="play-button"
                                                    sx={{ 
                                                        position: 'absolute', 
                                                        top: '50%', 
                                                        left: '50%', 
                                                        transform: 'translate(-50%, -50%)', 
                                                        width: 56, 
                                                        height: 56, 
                                                        borderRadius: '50%', 
                                                        bgcolor: 'rgba(255,255,255,0.3)', 
                                                        backdropFilter: 'blur(8px)', 
                                                        display: 'flex', 
                                                        alignItems: 'center', 
                                                        justifyContent: 'center',
                                                        border: '3px solid rgba(255,255,255,0.9)',
                                                        boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
                                                        transition: 'transform 0.3s ease'
                                                    }}
                                                >
                                                    <PlayArrowIcon sx={{ color: 'white', fontSize: 32, ml: 0.5 }} />
                                                </Box>
                                            </>
                                        )}
                                    </Box>
                                ) : (
                                    <Box sx={{ 
                                        width: '100%', 
                                        height: '100%', 
                                        background: 'linear-gradient(135deg, #1a2f63 0%, #11224d 50%, #0a1633 100%)', 
                                        display: 'flex', 
                                        alignItems: 'center', 
                                        justifyContent: 'center',
                                        position: 'relative'
                                    }}>
                                        <LinkIcon sx={{ color: 'white', fontSize: 56, opacity: 0.6 }} />
                                        <Box
                                            role="button"
                                            onClick={(e) => { e.stopPropagation(); setSelectedResource(resource); setIsPlayingExternal(true); }}
                                            className="play-button"
                                            sx={{ 
                                                position: 'absolute', 
                                                top: '50%', 
                                                left: '50%', 
                                                transform: 'translate(-50%, -50%)', 
                                                width: 56, 
                                                height: 56, 
                                                borderRadius: '50%', 
                                                bgcolor: 'rgba(255,255,255,0.12)', 
                                                display: 'flex', 
                                                alignItems: 'center', 
                                                justifyContent: 'center',
                                                border: '3px solid rgba(255,255,255,0.9)',
                                                boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
                                                transition: 'transform 0.3s ease',
                                                cursor: 'pointer'
                                            }}
                                        >
                                            <PlayArrowIcon sx={{ color: 'white', fontSize: 32, ml: 0.5 }} />
                                        </Box>
                                    </Box>
                                )}
                                
                                <Chip 
                                    label={resource.type === 'video' ? 'Video' : 'Link'} 
                                    size="small"
                                    sx={{ 
                                        position: 'absolute', 
                                        top: 12, 
                                        right: 12, 
                                        bgcolor: 'rgba(0,0,0,0.75)', 
                                        color: 'white', 
                                        fontWeight: 700, 
                                        fontSize: '0.7rem',
                                        height: 22,
                                        backdropFilter: 'blur(4px)',
                                        textTransform: 'uppercase',
                                        letterSpacing: '0.5px'
                                    }}
                                />
                            </Box>
                            
                            <Box sx={{ 
                                display: 'flex', 
                                flexDirection: 'column',
                                flexGrow: 1,
                                p: { xs: 2, sm: 2.5 },
                                height: 'calc(100% - 200px)',
                                overflow: 'hidden'
                            }}>
                                <Box sx={{ 
                                    display: 'flex', 
                                    alignItems: 'center', 
                                    gap: 0.5, 
                                    mb: 1.5,
                                    flexShrink: 0
                                }}>
                                    <CalendarMonthIcon sx={{ fontSize: 15, color: 'text.secondary' }} />
                                    <Typography variant="caption" sx={{ 
                                        color: 'text.secondary', 
                                        fontWeight: 500,
                                        fontSize: '0.7rem'
                                    }}>
                                        {new Date(resource.created_at).toLocaleDateString('en-US', { 
                                            month: 'short', 
                                            day: 'numeric', 
                                            year: 'numeric' 
                                        })}
                                    </Typography>
                                </Box>
                                
                                <Typography sx={{ 
                                    fontWeight: 700, 
                                    color: '#11224d', 
                                    mb: 1.5, 
                                    lineHeight: 1.4,
                                    fontSize: { xs: '1rem', sm: '1.05rem' },
                                    height: '2.8em',
                                    overflow: 'hidden',
                                    display: '-webkit-box',
                                    WebkitLineClamp: 2,
                                    WebkitBoxOrient: 'vertical',
                                    flexShrink: 0
                                }}>
                                    {resource.title}
                                </Typography>
                                
                                <Typography variant="body2" sx={{ 
                                    color: 'text.secondary',
                                    overflow: 'hidden',
                                    display: '-webkit-box',
                                    WebkitLineClamp: 2,
                                    WebkitBoxOrient: 'vertical',
                                    lineHeight: 1.6,
                                    fontSize: '0.85rem',
                                    flexShrink: 0,
                                    mb: 2,
                                    height: '3.2em'
                                }}>
                                    {resource.description || "No description provided."}
                                </Typography>
                                
                                <Box sx={{ flexGrow: 1 }} />
                                
                                <Box sx={{ 
                                    flexShrink: 0,
                                    mt: 'auto'
                                }}>
                                    <Button 
                                        variant="outlined" 
                                        fullWidth 
                                        size="medium"
                                        onClick={(e) => { e.stopPropagation(); setSelectedResource(resource); setIsPlayingExternal(resource.type !== 'video'); }}
                                        sx={{ 
                                            borderRadius: 2, 
                                            textTransform: 'none', 
                                            fontWeight: 700,
                                            fontSize: { xs: '0.85rem', sm: '0.9rem' },
                                            borderColor: '#e0e0e0',
                                            color: '#11224d',
                                            py: { xs: 0.9, sm: 1 },
                                            transition: 'all 0.2s ease',
                                            '&:hover': { 
                                                borderColor: '#ffb300', 
                                                bgcolor: alpha('#ffb300', 0.06),
                                                transform: 'translateY(-1px)',
                                                boxShadow: '0 2px 8px rgba(255, 179, 0, 0.2)'
                                            }
                                        }}
                                    >
                                        {resource.type === 'video' ? 'Watch Now' : 'Play'}
                                    </Button>
                                </Box>
                            </Box>
                        </Paper>
                    ))}
                </Box>
            )}
        </Container>
    );
};

export default TrainingViewer;